import { useState, useEffect } from 'react';
import CRTWrapper from '../shared/CRTWrapper';

const baseStyles = {
  titlebar: {
    background: '#c8c8c8',
    color: '#000',
    borderBottom: '3px solid #222',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    fontSize: 8,
    letterSpacing: 1,
    flexShrink: 0,
  },
  dot: (color) => ({
    width: 9,
    height: 9,
    borderRadius: '50%',
    background: color,
    border: '1px solid rgba(0,0,0,0.2)',
    flexShrink: 0,
  }),
  title: {
    flex: 1,
    textAlign: 'center',
  },
};

export default function DeviceFrame({ children, gearsUnlocked = 0 }) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 540);

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth <= 540);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  const gears = Math.max(0, Math.min(7, gearsUnlocked));
  const greenGlow = gears > 0
    ? `0 0 ${gears * 3}px rgba(0,255,65,${gears * 0.03})`
    : '';

  const dvh = CSS.supports?.('height', '100dvh') ? '100dvh' : '100vh';

  const frameStyle = isMobile
    ? {
        width: '100%',
        height: dvh,
        background: '#0a0a0a',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }
    : {
        width: '100%',
        maxWidth: 526,
        height: dvh,
        maxHeight: 526,
        background: '#0a0a0a',
        border: '3px solid #222',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        boxShadow: [
          '6px 6px 0 #000',
          'inset 0 0 30px rgba(0,0,0,0.5)',
          greenGlow,
        ].filter(Boolean).join(', '),
      };

  const titlebarStyle = {
    ...baseStyles.titlebar,
    padding: isMobile ? '5px 10px' : '3px 8px',
  };

  return (
    <CRTWrapper>
      <div style={frameStyle}>
        <div style={titlebarStyle}>
          <div style={baseStyles.dot('#ff5f56')} />
          <div style={baseStyles.dot('#ffbd2e')} />
          <div style={baseStyles.dot('#27c93f')} />
          <span style={baseStyles.title}>D.A.D. V.0001</span>
        </div>
        {children}
      </div>
    </CRTWrapper>
  );
}
